/**
 * Converts any string into a safe test ID by replacing spaces with underscores
 * and removing all special characters (including dashes).
 *
 * @param {string} inputString - The string to be converted
 * @returns {string} - A safe ID with only alphanumeric characters and underscores
 */
export function generateSafeTestId(inputString?: string): string {
  if (!inputString) return '';

  // First replace spaces with underscores
  let result = inputString.replace(/\s+/g, '_');

  // Then remove all non-alphanumeric characters (excluding underscores)
  result = result.replace(/[^a-zA-Z0-9_]/g, '');

  return result;
}
